import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Listbox } from "@headlessui/react";
import { useRecoilState } from "recoil";
import { FiSearch } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "assets/css/filter.css";
import { HiExternalLink, HiOutlineSelector } from "react-icons/hi";
import { MdCancel } from "react-icons/md";
import { ClipLoader } from "react-spinners";
import "../../assets/css/Blink.css";
import { formatTimeInMinutes } from "utils/formatTimeInMinutes";
import { formatToDateAndTime } from "utils/formatTime";
import {
  supportTaskModalState,
  isTasksUpdatedState,
} from "store/supportTasks/atoms/supportTasksState";
import IframeModal from "components/ChatStatus/IframeModal";
import UserDataPopup from "components/UserData/UserDataPopup";
import CreateTaskModal from "components/SupportTasks/CreateTaskModal/CreateTaskModal";
import { getToken } from "utils/getToken";
import { mobileNumberState } from "store/appointment/atoms/appointmentAtomState";
import {
  countBadge,
  emptyState,
  focusRing,
  ghostBtn,
  inlineLink,
  input as inputCls,
  pageKicker,
  pageTitle,
  primaryBtn,
  select as selectCls,
  table as tableCls,
  tablePanel,
  td,
  th,
  trHover,
} from "components/ui/instrument";

const getFormattedBackendDate = (date: any) => {
  if (!date) return null;
  const scheduledAtFromBackend = date;

  // Create a new Date object using the date string
  const dateObject = new Date(scheduledAtFromBackend);

  // Format the date according to the expected format ('yyyy-MM-ddTHH:mm')
  const formattedDate = `${dateObject.getFullYear()}-${(
    "0" +
    (dateObject.getMonth() + 1)
  ).slice(-2)}-${("0" + dateObject.getDate()).slice(-2)}T${(
    "0" + dateObject.getHours()
  ).slice(-2)}:${("0" + dateObject.getMinutes()).slice(-2)}`;

  return formattedDate;
};

const taskTypeOptions = [
  { value: "all", name: "All" },
  { value: "followup", name: "Followup" },
  { value: "custom_task", name: "Custom Task" },
  { value: "wa_tagged", name: "Whatsapp Tagged" },
  { value: "callback_request", name: "Callback request" },
  { value: "chat_notification", name: "whatsapp support" },
  { value: "chat_notification", name: "Parenting app qna request" },
  { value: "subscription_booked", name: "Subscription Booked" },
  { value: "history_form_not_filled", name: "Hitsory Form Not Filled" },
  { value: "webinar_registration", name: "Webinar Registration" },
  { value: "call_received", name: "Call Received" },
  { value: "spam_message_alert", name: "Spam Message Alert" },
  { value: "parenting_group_chat", name: "Parenting Group Chat" },
  { value: "appointment_cancellation", name: "Apointment Cancellation" },
  { value: "subscription_expired", name: "Subscription Expired" },
  { value: "subscription_lead", name: "Subscription Lead" },
];

const SupportTasks = () => {
  const [data, setData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filterPage, setFilterPage] = useState("");
  const [statusFilter, setStatusFilter] = useState(["pending"]);
  const [isChatStatusModalOpen, setIsChatStatusModalOpen] = useState(false);
  const [isChatStatusSaveButtonDisabled, setIsChatStatusSaveButtonDisabled] =
    useState(data.map(() => false));
  const [isFilterStatusMenuOpen, setIsFilterStatusMenuOpen] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [filterChanged, setFilterChanged] = useState(false);
  const [newStatus, setNewStatus] = useState("default");
  const [currentChatId, setCurrentChatId] = useState<any>(null);
  const [chatIndex, setChatIndex] = useState<any>(null);
  const [
    isChatStatusModalOpenSaveButttonDisable,
    setIsChatStatusModalOpenSaveButttonDisable,
  ] = useState(false);
  const [sortingMethod, setSortingMethod] = useState("asc");
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [mobileNumber, setMobileNumber] = useRecoilState(mobileNumberState);
  const [isSearchButtonClicked, setIsSearchButtonClicked] = useState(false);
  const [isSearchButtonLoading, setIsSearchButtonLoading] = useState(false);
  const [isPDataModalOpen, setIsPDataModalOpen] = useState(false);
  const [supportTaskModal, setSupportTaskModal] = useRecoilState(
    supportTaskModalState
  );
  const [isTasksUpdated, setIsTasksUpdated] =
    useRecoilState(isTasksUpdatedState);
  const [token, setToken] = useState(getToken());
  const [selectedTypeFilters, setSelectedTypeFilters] = useState([
    taskTypeOptions[1],
    taskTypeOptions[2],
    taskTypeOptions[3],
    taskTypeOptions[4],
    taskTypeOptions[5],
    taskTypeOptions[6],
    taskTypeOptions[7],
    taskTypeOptions[8],
    taskTypeOptions[9],
    taskTypeOptions[10],
    taskTypeOptions[11],
    taskTypeOptions[12],
    taskTypeOptions[13],
  ]);

  const retrieveConversation = async (retries = 0) => {
    try {
      setIsPageLoading(true);
      const formattedStatus = statusFilter.join(",");
      const queryParams: any = {
        status: statusFilter.length > 0 ? formattedStatus : null,
      };
      if (sortingMethod !== null && sortingMethod !== "default") {
        queryParams.sort_by = sortingMethod;
      }

      let taskTypeFilters: string[] = [];
      let formattedTaskTypeFilters;

      if (selectedTypeFilters.length > 0) {
        selectedTypeFilters.forEach((filter) => {
          if (filter.value !== "all") {
            taskTypeFilters.push(filter.value);
          }
        });
        formattedTaskTypeFilters = `${taskTypeFilters.join(",")}`;
      }

      if (formattedTaskTypeFilters) {
        queryParams.type = !selectedTypeFilters.includes(taskTypeOptions[0])
          ? formattedTaskTypeFilters
          : null;
      }

      if (filterChanged) {
        setCurrentPage(1);
      }
      if (currentPage) {
        queryParams.page = filterChanged ? 1 : currentPage;
      }
      if (mobileNumber) {
        queryParams.mobile = mobileNumber || "";
      }
      const apiUrl = process.env.REACT_APP_API_URL + "tasks/get-support-tasks/";
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
        params: queryParams,
      });
      if (filterChanged) {
        setFilterChanged(false);
      }
      setIsSearchButtonLoading(false);
      if (response.status === 200) {
        if (response.data.data.length === 0) {
          // Empty is a STATE of the table, not an error — it renders in the table
          // body below (the old corner toast disappeared before anyone read it).
          setData([]);
          setPendingTasksCount(0);
          setIsPageLoading(false);
        } else {
          setData(response.data.data);
          const count = response.data.data.filter(
            (item: any) => item.status === "pending"
          ).length;
          setPendingTasksCount(count);
          setIsPageLoading(false);
        }
      } else {
        toast.error("Failed to fetch data from the API.");
        setIsPageLoading(false);
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
      setIsPageLoading(false);
      toast.error("Error fetching data from the API.");
    } finally {
      setIsPageLoading(false);
    }
  };

  useEffect(() => {
    retrieveConversation();
  }, [currentPage, statusFilter, sortingMethod, selectedTypeFilters]);

  useEffect(() => {
    if (isTasksUpdated) {
      retrieveConversation();
      setIsTasksUpdated(false);
    }
  }, [isTasksUpdated]);

  // For filters

  // For status filter
  const handleStatusFilterChange = (value: string) => {
    setStatusFilter((prevStatusFilter) => {
      if (value === "all") {
        if (
          prevStatusFilter.includes("done") &&
          prevStatusFilter.includes("pending")
        ) {
          // If any of them is selected, deselect all
          return prevStatusFilter.filter(
            (item) => item !== "pending" && item !== "done"
          );
        } else {
          // If none of them are selected, select all
          setFilterChanged(true);
          return ["pending", "done"];
        }
      } else {
        if (prevStatusFilter.includes(value)) {
          return prevStatusFilter.filter((item) => item !== value);
        } else {
          setFilterChanged(true);
          return [...prevStatusFilter, value];
        }
      }
    });
  };

  // Close statusfilter on clicking outside
  const filterStatusMenuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        filterStatusMenuRef.current &&
        !filterStatusMenuRef.current.contains(event.target)
      ) {
        setIsFilterStatusMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // For ascending/descending sort
  const handleSortChange = (value: string) => {
    setSortingMethod(value);
    setFilterChanged(true);
  };

  const handlePageSearch = () => {
    const pageNumber = parseInt(filterPage);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
    window.scrollTo(0, 0);
    setData([]);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
    setData([]);
    window.scrollTo(0, 0);
  };

  // For changing status
  const handleChatStatusChangeEdit = (taskId: any, currentStatus: any, rowIndex: number) => {
    setIsChatStatusModalOpen(true);
    setCurrentChatId(taskId);
    setChatIndex(rowIndex);
    setNewStatus(currentStatus);
  };

  const handleChatStatusChange = async (taskId: any, currentStatus: string, rowIndex: number) => {
    const url = process.env.REACT_APP_API_URL + "tasks/edit-task-status/";
    const payload = {
      status: currentStatus,
      task_id: taskId,
    };
    try {
      setIsPageLoading(true);
      const updatedDisabledState = [...isChatStatusSaveButtonDisabled];
      updatedDisabledState[rowIndex] = true;
      setIsChatStatusSaveButtonDisabled(updatedDisabledState);
      const response = await axios.post(url, payload, {
        headers: {
          Authorization: `Token ${getToken()}`,
          "Content-Type": "application/json",
        },
      });
      // console.log(response);
      // console.log(response.data);
      if (response.status === 200) {
        const itemIndex = data.findIndex((item) => item.id === taskId);
        // console.log("itemIndex", itemIndex);

        if (itemIndex !== -1) {
          // Create a copy of the data array with the updated task_status
          const updatedData = [...data];
          updatedData[itemIndex].status = response.data.task_status;
          updatedData[itemIndex].updated_at = response.data.updated_at;
          // Update the state with the new data
          setData(updatedData);
          updatedDisabledState[rowIndex] = false;
          setIsChatStatusSaveButtonDisabled(updatedDisabledState);
          setIsChatStatusModalOpen(false);
          toast.success("Chat status updated successfully");
        }
      }
    } catch (error: any) {
      const updatedDisabledState = [...isChatStatusSaveButtonDisabled];

      updatedDisabledState[rowIndex] = false;
      setIsChatStatusSaveButtonDisabled(updatedDisabledState);

      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Error updating data:");
      }
    } finally {
      setIsPageLoading(false);
    }
  };

  const timeAgo = (dateTime: any) => {
    const messageDate = new Date(dateTime);
    const now = new Date();
    const differenceInMinutes = Math.round(
      ((now as any) - (messageDate as any)) / 60000
    );

    if (differenceInMinutes < 60) {
      return `${differenceInMinutes} minutes`;
    } else {
      // Handle hours or days if needed
      const differenceInHours = Math.round(differenceInMinutes / 60);
      if (differenceInHours < 24) {
        return `${differenceInHours} hours`;
      } else {
        const differenceInDays = Math.round(differenceInHours / 24);
        return `${differenceInDays} days`;
      }
    }
  };

  // For navigating to that particular chat
  // For navigating to that particular chat
  const [highlightedRow, setHighlightedRow] = useState<any>(null);
  const [modalContent, setModalContent] = useState<any>(null);

  function createLinkAndOpenChat(row: any, rowIndex: number) {
    if (!row.scheduled_at) {
      return "";
    }

    const chatStartTime = new Date(row.scheduled_at);
    const startTimeOffset = chatStartTime.getTimezoneOffset();

    const lastMessageTime = new Date(row.scheduled_at);
    const lastMessageTimeOffset = lastMessageTime.getTimezoneOffset();
    const startTime = new Date(
      chatStartTime.getTime() - 10 * 60 * 1000 - startTimeOffset * 60 * 1000
    );
    const endTime = new Date(
      lastMessageTime.getTime() +
        10 * 60 * 1000 -
        lastMessageTimeOffset * 60 * 1000
    );
    const startTimeISO = startTime.toISOString().slice(0, 19);
    const endTimeISO = endTime.toISOString().slice(0, 19);

    const url = `/whatsapp-chat?group_id=${
      row.all_details.whatsappgroup_id
    }&start_time=${startTimeISO}&end_time=${endTimeISO}&mobile_number=${row.all_details.user_details.user_mobile.slice(
      1
    )}`;

    setHighlightedRow(rowIndex);
    setModalContent({ url });
  }

  const closeModal = () => {
    setModalContent(null);
  };

  const refreshData = () => {
    retrieveConversation();
  };

  // For chat count
  const [pendingTasksCount, setPendingTasksCount] = useState(0);
  const currentTime = new Date();
  const [serverSyncTime, setServerSyncTime] = useState<any>(currentTime);

  const timeDifference = serverSyncTime
    ? (currentTime as any) - (new Date(serverSyncTime) as any)
    : null;

  const isTimeDifferenceExceeded =
    timeDifference && timeDifference > 15 * 60 * 1000;

  const handlePDataModal = (row: any) => {
    setSelectedUser(row?.all_details?.user_details?.user_mobile);
    // console.log(row.Chat_started_by);
    setIsPDataModalOpen(true);
  };

  const handlePDataModalClose = () => {
    setIsPDataModalOpen(false);
    setSelectedUser(null);
  };

  const handleTaskTypeFilterChange = (newSelectedStatuses: any[]) => {
    if (newSelectedStatuses.includes(taskTypeOptions[0])) {
      if (
        newSelectedStatuses.length === taskTypeOptions.length - 1 &&
        selectedTypeFilters.includes(taskTypeOptions[0])
      ) {
        setSelectedTypeFilters(
          newSelectedStatuses.filter((status) => status.value !== "all")
        );
        setFilterChanged(true);
      } else {
        setSelectedTypeFilters(taskTypeOptions);
        setFilterChanged(true);
      }
    } else if (
      !selectedTypeFilters.includes(taskTypeOptions[0]) &&
      newSelectedStatuses.length >= taskTypeOptions.length - 1
    ) {
      setSelectedTypeFilters(taskTypeOptions);
      setFilterChanged(true);
    } else if (
      selectedTypeFilters.includes(taskTypeOptions[0]) &&
      newSelectedStatuses.length >= taskTypeOptions.length - 1
    ) {
      setSelectedTypeFilters([]);
      setFilterChanged(true);
    } else {
      setSelectedTypeFilters(newSelectedStatuses);
      setFilterChanged(true);
    }
  };

  const handleMobileNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const mobileNumberData = e.target.value.replace(/[^\d+]/g, "");
    setMobileNumber(mobileNumberData);
    setIsSearchButtonClicked(true);
  };

  const handleSearchButtonClick = () => {
    setIsSearchButtonLoading(true);
    setCurrentPage(1);

    if (mobileNumber.length < 7) {
      toast.error("Please Enter the Correct Mobile number!");
      setIsSearchButtonLoading(false);
      return;
    }
    retrieveConversation();
  };
  useEffect(() => {
    setMobileNumber("");
  }, []);

  return (
    <>
      <CreateTaskModal />

      <div className="mx-auto sm:w-full">
        {modalContent && (
          <IframeModal onClose={closeModal} url={modalContent.url} />
        )}

        {isPDataModalOpen && (
          <UserDataPopup
            selectedUser={selectedUser}
            noSearch={true}
            handlePDataModalClose={handlePDataModalClose}
          />
        )}

        {/* Live Chat section */}
        <div className="mb-5 px-4 py-4">
          {/* Header. Sync health is an instrument light beside the title — solid
              crit chip when stale (no blink: a steady alarm reads better and
              respects reduced motion), quiet neutral chip when healthy. */}
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <p className={pageKicker}>Babynama Clinic-OS</p>
              <h1 className={pageTitle}>Pending Tasks</h1>
              <div className="mt-1.5 flex flex-wrap items-center gap-2">
                <span
                  role={isTimeDifferenceExceeded ? "alert" : undefined}
                  className={`inline-flex items-center gap-1.5 rounded px-1.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-[0.12em] ${
                    isTimeDifferenceExceeded
                      ? "bg-crit-600 text-white"
                      : "bg-clinic-100 text-clinic-600 ring-1 ring-clinic-200"
                  }`}
                >
                  <span
                    aria-hidden="true"
                    className={`h-1.5 w-1.5 rounded-full ${
                      isTimeDifferenceExceeded ? "bg-white" : "bg-clinic-400"
                    }`}
                  />
                  Last message synced on server:{" "}
                  {formatTimeInMinutes(serverSyncTime)}
                  {isTimeDifferenceExceeded ? " · Contact Tech Team." : ""}
                </span>
                <span className="text-xs text-clinic-500">
                  Total Pending Tasks:{" "}
                  <span
                    className={`${countBadge} ${
                      pendingTasksCount > 0 ? "!bg-crit-100 !text-crit-700" : ""
                    }`}
                  >
                    {pendingTasksCount}
                  </span>
                </span>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={() => {
                  setSupportTaskModal({
                    open: true,
                    taskId: null,
                    taskDetails: null,
                    type: "add",
                  });
                }}
                className={primaryBtn}
              >
                Create Task
              </button>

              <button className={ghostBtn} onClick={() => refreshData()}>
                Refresh
              </button>
            </div>
          </div>

          {/* Filters */}
          <div className="flex flex-col py-4 md:flex-row md:justify-between ">
            {/* Filter using task type */}

            {/* Mobile search */}
            <div className="flex w-72 items-center gap-2">
              <input
                type="text"
                placeholder="User Phone Number"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                className={`${inputCls} tabular-nums`}
              />
              <button
                className={`${primaryBtn} shrink-0`}
                onClick={handleSearchButtonClick}
                disabled={isSearchButtonLoading}
              >
                {isSearchButtonLoading ? "Loading..." : "Search"}
              </button>
            </div>

            <div className="">
              {/* <span className="mr-2">Filter by Status:</span> */}
              <Listbox
                value={selectedTypeFilters}
                onChange={handleTaskTypeFilterChange}
                multiple
              >
                {({ open }) => (
                  <>
                    <div className="relative inline-block text-left">
                      <Listbox.Button
                        className={`inline-flex w-full items-center justify-center gap-3 rounded-md border border-clinic-300 bg-white px-3 py-1.5 text-sm text-clinic-700 hover:bg-clinic-50 ${focusRing}`}
                      >
                        <span
                          className={
                            selectedTypeFilters.length > 0
                              ? "font-medium tabular-nums text-clinic-900"
                              : ""
                          }
                        >
                          {selectedTypeFilters.length > 0
                            ? `${selectedTypeFilters.length} Filter Selected`
                            : "Filter By Type"}
                        </span>
                        <HiOutlineSelector
                          size="18"
                          className="text-clinic-400"
                          aria-hidden="true"
                        />
                      </Listbox.Button>
                    </div>
                    <Listbox.Options
                      className="absolute z-10 mt-1 max-h-60 min-w-[200px] overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-clinic-200 focus:outline-none"
                      style={{ display: open ? "block" : "none" }}
                    >
                      {taskTypeOptions.map((option, index) => (
                        <Listbox.Option
                          key={index}
                          value={option}
                          className={({ active }) =>
                            `${
                              active ? "bg-clinic-100" : ""
                            } relative cursor-pointer select-none py-1.5 pl-3 pr-3 text-clinic-700`
                          }
                        >
                          {({ selected }) => (
                            <>
                              <div className="flex items-center gap-2.5">
                                <input
                                  type="checkbox"
                                  checked={selected ? true : false}
                                  readOnly
                                  className="cursor-pointer accent-[#0e7490]"
                                />
                                <span
                                  className={`${
                                    selected
                                      ? "font-semibold text-clinic-900"
                                      : "font-normal"
                                  }`}
                                >
                                  {option.name}
                                </span>
                              </div>
                            </>
                          )}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </>
                )}
              </Listbox>
            </div>

            {/* Filter by status */}
            <div className="flex flex-col">
              <div
                className="flex w-[80vw] flex-col rounded-xl md:w-auto"
                ref={filterStatusMenuRef}
              >
                <button
                  id="dropdownCheckboxButton"
                  className={`relative inline-flex items-center rounded-md border border-clinic-300 bg-white px-3 py-1.5 text-sm transition-colors hover:bg-clinic-50 motion-reduce:transition-none ${
                    statusFilter.length > 0
                      ? "font-medium tabular-nums text-clinic-900"
                      : "text-clinic-700"
                  } ${focusRing}`}
                  type="button"
                  onClick={() =>
                    setIsFilterStatusMenuOpen(!isFilterStatusMenuOpen)
                  }
                >
                  {statusFilter.length > 0 ? (
                    <>
                      {statusFilter.length} Status Selected
                      <svg
                        className={`ml-2.5 h-2.5 w-2.5 transform ${
                          isFilterStatusMenuOpen ? "rotate-180" : ""
                        }`}
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 10 6"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="m1 1 4 4 4-4"
                        />
                      </svg>
                      <span
                        className="ml-2 cursor-pointer text-clinic-400 hover:text-clinic-600"
                        role="button"
                        aria-label="Clear status filter"
                        onClick={(e) => {
                          e.stopPropagation();
                          setStatusFilter([]);
                        }}
                      >
                        <MdCancel />
                      </span>
                    </>
                  ) : (
                    <>
                      Filter By Status
                      <svg
                        className={`ml-2.5 h-2.5 w-2.5 transform ${
                          isFilterStatusMenuOpen ? "rotate-180" : ""
                        }`}
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 10 6"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="m1 1 4 4 4-4"
                        />
                      </svg>
                    </>
                  )}
                </button>

                {isFilterStatusMenuOpen && (
                  <div
                    id="dropdownDefaultCheckbox"
                    className="absolute z-10 mt-11 w-[180px] rounded-md bg-white py-1 shadow-lg ring-1 ring-clinic-200 focus:outline-none"
                  >
                    <ul
                      className="space-y-1 p-2 text-sm text-clinic-700"
                      aria-labelledby="dropdownCheckboxButton"
                    >
                      <li>
                        <div className="flex items-center">
                          <input
                            id="checkbox-item-all"
                            type="checkbox"
                            className={`h-4 w-4 cursor-pointer rounded accent-[#0e7490] ${focusRing}`}
                            value="all"
                            onChange={() => handleStatusFilterChange("all")}
                            checked={
                              statusFilter.includes("pending") &&
                              statusFilter.includes("done")
                            }
                          />
                          <label
                            htmlFor="checkbox-item-live-chat"
                            className="ml-2 w-full cursor-pointer text-sm font-medium text-clinic-700"
                          >
                            All
                          </label>
                        </div>
                      </li>
                      <li>
                        <div className="flex items-center">
                          <input
                            id="checkbox-item-live-chat"
                            type="checkbox"
                            className={`h-4 w-4 cursor-pointer rounded accent-[#0e7490] ${focusRing}`}
                            value="live-chat"
                            onChange={() => handleStatusFilterChange("pending")}
                            checked={statusFilter.includes("pending")}
                          />
                          <label
                            htmlFor="checkbox-item-live-chat"
                            className="ml-2 w-full cursor-pointer text-sm font-medium text-clinic-700"
                          >
                            Pending Tasks
                          </label>
                        </div>
                      </li>
                      <li>
                        <div className="flex items-center">
                          <input
                            id="checkbox-item-2"
                            type="checkbox"
                            className={`h-4 w-4 cursor-pointer rounded accent-[#0e7490] ${focusRing}`}
                            value="done"
                            onChange={() => handleStatusFilterChange("done")}
                            checked={statusFilter.includes("done")}
                          />
                          <label
                            htmlFor="checkbox-item-2"
                            className="ml-2 w-full cursor-pointer text-sm font-medium text-clinic-700"
                          >
                            Closed Tasks
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>

            {/* Ascending/ descending filter */}
            <div className="relative inline-flex items-center">
              <select
                id="ascendingDescending"
                className={`${selectCls} ${
                  sortingMethod !== "default" && sortingMethod !== null
                    ? "font-medium !text-clinic-900"
                    : ""
                }`}
                value={sortingMethod}
                onChange={(e) => {
                  handleSortChange(e.target.value);
                }}
              >
                <option value="default">Choose sorting format</option>
                <option value="asc">Ascending</option>
                <option value="desc">Descending</option>
              </select>
              {sortingMethod && sortingMethod !== "default" && (
                <button
                  className={`z-50 ml-2 cursor-pointer rounded text-clinic-400 hover:text-clinic-600 ${focusRing}`}
                  aria-label="Clear sorting"
                  onClick={() => setSortingMethod("default")}
                >
                  <MdCancel />
                </button>
              )}
            </div>
          </div>
          {/* Filters end */}

          {/* For desktop view */}
          {!isPageLoading ? (
            <div className={tablePanel}>
              <table className={tableCls}>
                <thead>
                  <tr>
                    <th className={th}>User's Details</th>
                    <th className={th}>Tasks</th>
                    <th className={`max-w-[200px] ${th}`}>Details</th>
                    <th className={th}>Created At</th>
                    <th className={`min-w-[150px] ${th}`}>Scheduled At</th>
                    <th className={th}>Link</th>
                    <th className={th}>Status</th>
                    <th className={th}>Actions</th>
                    <th className={th}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Empty is a state of THIS surface — it renders where the rows
                      would be, not as a toast in a corner. */}
                  {data.length === 0 && (
                    <tr>
                      <td colSpan={9} className={emptyState}>
                        No tasks match the selected filters.
                      </td>
                    </tr>
                  )}
                  {data.map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className={
                        rowIndex === highlightedRow || !row?.scheduled_at
                          ? "bg-warn-50 hover:bg-warn-100"
                          : trHover
                      }
                    >
                      <td className={td}>
                        {row?.all_details?.user_details?.user_name ||
                        row?.all_details?.user_details?.user_mobile ? (
                          <div>
                            <p className="font-semibold text-clinic-900">
                              {row?.all_details?.user_details?.user_name}
                            </p>
                            <button
                              type="button"
                              className={`mt-1 flex items-center gap-1.5 tabular-nums ${inlineLink}`}
                              onClick={() => {
                                handlePDataModal(row);
                              }}
                            >
                              {row?.all_details?.user_details?.user_mobile}
                              <HiExternalLink aria-hidden="true" />
                            </button>
                          </div>
                        ) : null}
                      </td>
                      <td className={td}>
                        {row?.task || row?.type}
                      </td>

                      <td className={td}>
                        {row?.all_details?.details?.length > 0 &&
                          row.all_details.details.map(
                            (detail: any, index: number) => (
                            <div key={index} className="space-y-2">
                              {Object.entries(detail).map(
                                ([key, value]: [string, any]) => {
                                if (value) {
                                  let formattedValue = value;
                                  if (
                                    [
                                      "started_at",
                                      "ending_at",
                                      "event_time",
                                    ].includes(key)
                                  ) {
                                    formattedValue = formatToDateAndTime(value);
                                  }
                                  const formattedKey = key.replace(/_/g, " ");
                                  return (
                                    <p key={key} className="my-2">
                                      <span className="font-bold">
                                        {formattedKey.charAt(0).toUpperCase() +
                                          formattedKey.slice(1)}
                                      </span>{" "}
                                      - {formattedValue}
                                    </p>
                                  );
                                }
                                return null;
                              })}
                            </div>
                          ))}
                      </td>

                      <td className={`${td} tabular-nums`}>
                        <div className="space-y-2">
                          <p className="">
                            <span>
                              {row?.created_at
                                ? formatToDateAndTime(row?.created_at)
                                : null}
                            </span>
                          </p>
                        </div>
                      </td>

                      <td className={`${td} tabular-nums`}>
                        <div className="flex items-center gap-2 space-y-2">
                          <p className="">
                            <span>
                              {row?.scheduled_at
                                ? formatToDateAndTime(row?.scheduled_at)
                                : null}
                            </span>
                          </p>
                        </div>
                      </td>

                      <td className={td}>
                        {
                        row.all_details &&
                        row.all_details.whatsappgroup_id ? (
                          <button
                            className={`flex items-center gap-1.5 text-sm ${inlineLink}`}
                            onClick={() => {
                              createLinkAndOpenChat(row, rowIndex);
                            }}
                          >
                            Open chat <HiExternalLink size={16} aria-hidden="true" />
                          </button>
                        ) : row.all_details && row.all_details.chat_link ? (
                          <a
                            className={`flex items-center gap-1.5 text-sm ${inlineLink}`}
                            href={row.all_details.chat_link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Open chat <HiExternalLink size={16} aria-hidden="true" />
                          </a>
                        ) : (
                          <span className="text-clinic-400">Not available</span>
                        )}
                      </td>

                      <td className={td}>
                        {/* Status = state, not decoration: pending is the one
                            alarm-worthy state (warn), done recedes to neutral. */}
                        <span
                          className={`inline-block rounded px-1.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-[0.12em] ${
                            row.status === "pending"
                              ? "bg-warn-100 text-warn-700 ring-1 ring-warn-200"
                              : "bg-clinic-100 text-clinic-600 ring-1 ring-clinic-200"
                          }`}
                        >
                          {row.status ? row.status : "Not available"}
                        </span>
                        <button
                          className={`mt-2 block ${primaryBtn}`}
                          onClick={() =>
                            handleChatStatusChange(row.id, "done", rowIndex)
                          }
                          disabled={isChatStatusSaveButtonDisabled[rowIndex]}
                        >
                          {isChatStatusSaveButtonDisabled[rowIndex]
                            ? "Please Wait..."
                            : "Done"}
                        </button>
                      </td>

                      <td className={td}>
                        <button
                          className={ghostBtn}
                          onClick={() => {
                            setSupportTaskModal({
                              open: true,
                              taskId: row.id,
                              taskDetails: {
                                scheduled_at: getFormattedBackendDate(
                                  row.scheduled_at
                                ),
                                remarks: row.remarks || [],
                                user_name:
                                  row.all_details.user_details.user_name,
                                mobile:
                                  row.all_details.user_details.user_mobile,
                                status: row.status,
                                type: row.type,
                              },
                              type: "edit",
                            });
                          }}
                        >
                          Edit
                        </button>
                      </td>

                      <td className={td}>
                        {row?.remarks?.length > 0 && (
                          <div className="space-y-4">
                            {row.remarks && (
                              <div>
                                {row.remarks.map((remark: any, index: number) => (
                                  <div key={index} className="space-y-2">
                                    {Object.entries(remark).map(
                                      ([key, value]: [string, any]) => {
                                        const formattedKey = key.replace(
                                          /_/g,
                                          " "
                                        );
                                        return (
                                          <p key={key} className="my-2">
                                            <span className="font-bold">
                                              {formattedKey
                                                .charAt(0)
                                                .toUpperCase() +
                                                formattedKey.slice(1)}
                                            </span>{" "}
                                            - {value}
                                          </p>
                                        );
                                      }
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="flex h-[70vh] items-center justify-center">
              <ClipLoader color={"#0891b2"} size={60} />
            </div>
          )}

          <div className="mt-6 flex flex-col justify-center gap-3 md:flex-row">
            <div className="flex items-center justify-center gap-2 md:ml-auto">
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className={ghostBtn}
              >
                <span aria-hidden="true">←</span> Previous Page
              </button>

              <h3 className="flex items-center px-2 text-sm tabular-nums text-clinic-700">
                Page {currentPage}
              </h3>

              <button
                onClick={handleNextPage}
                // disabled={currentPage === totalPages}
                className={ghostBtn}
              >
                Next Page <span aria-hidden="true">→</span>
              </button>
            </div>
            <div className="mt-3 flex items-center justify-end gap-2 md:ml-auto md:mt-0">
              <input
                type="text"
                placeholder={`Go to page (1 - ${totalPages})`}
                value={filterPage}
                onChange={(e) => setFilterPage(e.target.value)}
                className={`w-44 ${inputCls} tabular-nums`}
              />
              <button
                className={ghostBtn}
                aria-label="Go to page"
                onClick={handlePageSearch}
              >
                <FiSearch className="h-4 w-4" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <hr />

        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default SupportTasks;
